import { useTranslation } from "react-i18next";
import { useRef } from 'react';

function PopupInfo(props) {
    const { t } = useTranslation();
    const pinRef = useRef(null);
    const codeRef = useRef(null);

    const handleDoubleClick = (elt) => {
        if (elt === 'pin' && pinRef.current) {
          const range = document.createRange();
          range.selectNodeContents(pinRef.current);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }else if (elt === 'code' && codeRef.current) {
          const range = document.createRange();
          range.selectNodeContents(codeRef.current);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
    };
    
    return (props.data && (
            <div name={props.info?.name} className="wb-popup">
                <div className="wb-popup-content">
                    <div style={{position: "relative"}}>
                        <span onClick={(e) => props.close(e, "close")} className="wb-close-x">&#10005;</span>
                    </div>
                    <h2>{t(props.data.title?.i18N)}</h2>
                    <p style={{fontSize: "13px"}}>{t(props.data.txt?.i18N)}</p>
                    <div className='wb-mb-3' style={{fontSize: "13px"}}>
                        {props.data.method?.value && <div className='wb-mb-1' dangerouslySetInnerHTML={{__html: t(props.data.method?.i18N, {method: props.data.method?.value})}} />}

                        {props.data.link?.value && <div className='wb-mb-1' dangerouslySetInnerHTML={{__html: t(props.data.link?.i18N,{link: props.data.link?.value})}} />}

                        {props.data.code?.value && <div className='wb-mb-1' >
                            <span dangerouslySetInnerHTML={{__html: t(props.data.code?.i18N)}}/>
                            <span ref={codeRef} onDoubleClick={() => handleDoubleClick('code')}>{props.data.code?.value}</span>
                        </div>}

                        {props.data.pin?.value && <div className='wb-mb-1'>
                            <span dangerouslySetInnerHTML={{__html: t(props.data.pin?.i18N)}}/>
                            <span ref={pinRef} onDoubleClick={() => handleDoubleClick('pin')}>{props.data.pin?.value}</span>
                        </div>}
                    </div>
                    <div className='wb-mt'>
                        <button 
                            style={{float: "right"}}
                            className='wb-button-blue'
                            onClick={props.close}
                        >{t("btn.close")}</button>
                    </div>
                </div>
            </div>
        )
    );
}

export default PopupInfo;